import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const Context = createContext(null);

const UserContext = ({children}) => {
    const [userInfo, setUserInfo] = useState(null);
    const [token, setToken] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [activeMenu, setActiveMenu] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const user = JSON.parse(sessionStorage.getItem('user'));
        const token = sessionStorage.getItem('token');
        if(user) {
            setUserInfo(user);
            setToken(token);
            setUserRole(user.role);
        }
        else{
            navigate('/auth/login');
        } 
    }, [navigate])

    const logout = () => {
        setUserInfo(null);
        setToken(null);
        setUserRole(null);
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");
        navigate("/auth/login");
    };

    return (
        <Context.Provider value={{ userInfo, setUserInfo, token, setToken, userRole, setUserRole, activeMenu, setActiveMenu, logout }}>
            {children}
        </Context.Provider>
    )
}

export default UserContext;